import { useEffect } from "react";
import Lenis from "lenis";
import { MessageCircle } from "lucide-react";
import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";
import { whatsappLink } from "./i18n/translations";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Gallery } from "./components/Gallery";
import { Specs } from "./components/Specs";
import { Services } from "./components/Services";
import { Vision } from "./components/Vision";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { ReservationPopups } from "./components/Popups";
import { Footer } from "./components/Footer";

const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <a
      data-testid="whatsapp-float-button"
      href={whatsappLink(t.whatsapp_message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-5 end-5 z-[70] w-14 h-14 flex items-center justify-center rounded-full bg-[#C5A059] text-black shadow-[0_10px_36px_rgba(197,160,89,0.4)] hover:bg-[#EED8A1] hover:scale-105 transition-all duration-300 pulse-gold"
    >
      <MessageCircle size={24} />
    </a>
  );
};

const Site = () => (
  <div className="bg-[#050505] min-h-screen text-[#F7F3E9]">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Gallery />
      <Specs />
      <Services />
      <Vision />
      <About />
      <Contact />
    </main>
    <Footer />
    <ReservationPopups />
    <FloatingWhatsApp />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
